import { MouseEvent, useState } from 'react';
import { IconButton } from '@components/iconButton';
import { Menu, IMenuItem } from '@components/menu';
import { Tooltip } from '@components/tooltip/Tooltip';
import { EllipsisH } from '@assets/svgs';

interface ITooltipAdditionalActions {
  items: IMenuItem[];
  onCloseMenu?: () => void;
}

export const TooltipAdditionalActions = (props: ITooltipAdditionalActions) => {
  const { items, onCloseMenu } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);

  const handleOnOpenMenu = (event: MouseEvent<HTMLElement | null>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOnCloseMenu = () => {
    setAnchorEl(null);
    if (typeof onCloseMenu === 'function') {
      onCloseMenu();
    }
  };
  const handleOnClickMenuItem = (index: number) => {
    handleOnCloseMenu();
    items[index]?.action?.();
  };

  return (
    <>
      <Tooltip placement='top' title='Additional Actions'>
        <IconButton
          id='additional-actions-button'
          aria-controls={openMenu ? 'additional-actions-menu' : undefined}
          aria-expanded={openMenu ? 'true' : undefined}
          aria-haspopup='true'
          variant='rounded'
          size='small'
          onClick={handleOnOpenMenu}
        >
          <EllipsisH width='11px' height='3px' />
        </IconButton>
      </Tooltip>
      <Menu
        id='additional-actions-menu'
        aria-labelledby='additional-actions-button'
        open={openMenu}
        anchorEl={anchorEl}
        items={items}
        onClickMenuItem={handleOnClickMenuItem}
        onClose={handleOnCloseMenu}
        sx={{ marginLeft: '4px' }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      />
    </>
  );
};
